import DeleteMenuApi from "./DeleteMenuApi";
const DeleteMenuServices = async (id: string): Promise<any> => {
    try {
        const res = await DeleteMenuApi(
            id
        )
        return res;
    } catch (error) {
        throw error
    }
};
export default DeleteMenuServices;